import { Shield, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

/**
 * Forbidden Access Component
 *
 * Displays when user doesn't have required permissions or role access
 */
const Forbidden = ({
  title = '403 - Access Denied',
  message = "You don't have permission to access this resource.",
  showBackButton = true,
  backPath = '/',
  customActions = null,
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(backPath);
  };

  return (
    <div className='min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-md'>
        <Card className='shadow-lg'>
          <CardHeader className='text-center'>
            <div className='mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4'>
              <Shield className='h-6 w-6 text-red-600' />
            </div>
            <CardTitle className='text-2xl font-bold text-gray-900'>
              {title}
            </CardTitle>
          </CardHeader>

          <CardContent className='text-center space-y-6'>
            <p className='text-sm text-gray-600'>{message}</p>

            <div className='text-xs text-gray-500 bg-gray-100 p-3 rounded-lg'>
              <p className='font-medium mb-1'>Possible reasons:</p>
              <ul className='text-left space-y-1'>
                <li>• Your account doesn&apos;t have the required permissions</li>
                <li>• Your role level is insufficient for this action</li>
                <li>• The resource requires specific access rights</li>
                <li>• Your session may have expired</li>
              </ul>
            </div>

            <div className='flex flex-col sm:flex-row gap-3 justify-center'>
              {showBackButton && (
                <Button
                  onClick={handleGoBack}
                  variant='outline'
                  className='flex items-center gap-2'
                >
                  <ArrowLeft className='h-4 w-4' />
                  Go Back
                </Button>
              )}

              <Button
                onClick={() => window.location.reload()}
                variant='default'
              >
                Refresh Page
              </Button>
            </div>

            {customActions && (
              <div className='pt-4 border-t border-gray-200'>
                {customActions}
              </div>
            )}

            <div className='text-xs text-gray-400'>
              <p>
                If you believe this is an error, please contact your
                administrator.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Forbidden;
